// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"188bc2da","703":"0d8e6236","787":"f581ceff"}[chunkId] + ".chunk.js";
};